"use strict";
'use strict';

var status = require('./status.cjs');



exports.Indicator = status.StatusIndicator;
exports.PropsProvider = status.StatusPropsProvider;
exports.Root = status.StatusRoot;
